<template>
	<Layout class="layout">
		<Header class="header">
			<Row class="header-row" type="flex" align="middle">
				<Col :xs="1" :sm="8" :md="5" class="text-left logo-wrapper">
					<img class="logo" src="@/assets/images/logo.png">
				</Col>
				<Col :xs="19" :sm="9" :md="13" offset="1"></Col>
				<Col :xs="3" :sm="6" :md="5">
					<span class="pull-right text-nowrap">
						<Dropdown class="language-dropdown" @on-click="handleLanguage">
							<span class="title">
								{{currentLanguage.label}}
								<Icon type="ios-arrow-down"/>
							</span>
							<DropdownMenu slot="list">
								<DropdownItem
									v-for="lang in availableLanguages"
									:key="lang.value"
									:name="lang.value"
								>{{lang.label}}</DropdownItem>
							</DropdownMenu>
						</Dropdown>
						<Dropdown v-if="currentUser" class="user-dropdown" @on-click="handleUserOperation">
							<span class="title">
								{{currentUser.Name}}
								<Icon class="icon" type="ios-contact-outline"/>
							</span>
							<DropdownMenu slot="list">
								<DropdownItem name="changePassword">{{$t('更改密碼')}}</DropdownItem>
							</DropdownMenu>
							<DropdownMenu slot="list">
								<DropdownItem name="logout">{{$t('登出')}}</DropdownItem>
							</DropdownMenu>
						</Dropdown>
					</span>
				</Col>
			</Row>
			<Row class="header-sub-row" type="flex" align="middle">
				<Col class="text-left" :xs="18" :sm="10" :md="6" offset="1">
					<router-link to="/home">{{$t('新生報到首頁')}}</router-link>
					<Divider type="vertical"/>
					<a href="https://www.ntnu.edu.tw/">{{$t('回師大')}}</a>
					<Divider type="vertical"/>
					<router-link to="/contact-us">{{$t('聯絡我們')}}</router-link>
				</Col>
			</Row>
		</Header>
		<Content class="content">
			<router-view/>
		</Content>
		<Footer class="footer text-center">{{copyRight}}</Footer>
	</Layout>
</template>

<script>
import SystemSettingService from '@/services/SystemSettingService'
import Vue from 'vue'

export default {
	data() {
		return {
			form: {
				Token: this.$route.query.token,
				NewPassword: '',
				NewPasswordAgain: '',
			},
			languages: [
				{
					label: 'English',
					value: 'en',
				},
				{
					label: '繁體中文',
					value: 'tw',
				},
			],
			copyRight: '',
			currentUser: null,
		}
	},
	computed: {
		//目前選取的語言
		currentLanguage() {
			return this.languages.find(lang => lang.value === this.$i18n.locale)
		},
		//可以選取的語言
		availableLanguages() {
			return this.languages.filter(lang => lang.value !== this.$i18n.locale)
		},
	},
	async created() {
		if (localStorage.getItem('language')) {
			this.handleLanguage(localStorage.getItem('language'))
		}

		//當需要權限，則先取得使用者
		if (!this.$route.meta.allowAnonymous) {
			this.getCurrentUser(() => {})
		}

		let { CopyRight } = await SystemSettingService.get('CopyRight')
		this.copyRight = CopyRight
	},
	//在路由更新前檢查頁面是否需要登入
	beforeRouteUpdate(to, from, next) {
		//當頁面不需要登入或已經有使用者，則轉頁，否則先取得登入使用者
		if (to.meta.allowAnonymous || this.$currentUser) {
			next()
		} else {
			this.getCurrentUser(next)
		}
	},
	methods: {
		async changePassword() {
			this.$router.push(`/password/change`) //跳至修改密碼頁面
		},
		async logout() {
			try {
				await this.$http.delete('api/Login')
				this.currentUser = Vue.prototype.$currentUser = null //清除使用者
				this.$router.push('/login')
			} catch (err) {
				console.log(err)
			}
		},
		async getCurrentUser(next) {
			try {
				let response = await this.$http.get('api/User/me')
				this.currentUser = Vue.prototype.$currentUser = response.data //存到全域
				next()
			} catch (err) {
				console.log(err)
				this.$Message.error(this.$t('尚未登入'))
				this.$router.push('/login')
			}
		},
		//切換語言
		handleLanguage(langauge) {
			this.$i18n.locale = langauge
			localStorage.setItem('language', langauge)
		},
		//使用者操作
		handleUserOperation(name) {
			switch (name) {
				case 'changePassword':
					this.changePassword()
					break
				case 'logout':
					this.logout()
					break
			}
		},
	},
}
</script>
<style lang="scss" scoped>
.layout {
	min-height: 100vh;
	height: 100%;
	padding-bottom: 5%;

	.header {
		height: 112px;
		margin-bottom: 15px;
		padding: 0px !important;

		.header-row {
			height: 64px;
			padding: 0 10%;
			margin: 0px !important;
		}

		.header-sub-row {
			height: 48px;
			background: white;
			padding: 0 10%;
			margin: 0px !important;

			a {
				color: lightslategray;
			}
		}
	}

	.content {
		background: #f5f7f9;
		height: auto;
	}

	.footer {
		background-color: lightgray;
		padding: 12px 50px;
		position: absolute;
		bottom: 0px;
		width: 100%;
	}
}
.logo-wrapper {
	height: 64px;
	.logo {
		width: 270px;
	}
}

.language-dropdown {
	.title {
		color: white;
		font-size: 14px;
	}
}

.user-dropdown {
	margin-left: 30px;
	.title {
		color: white;
		font-size: 18px;
		.icon {
			font-size: 25px;
		}
	}
}
</style>
